import { Container } from '@chakra-ui/react';
import React from 'react';
import Educard from './Educard';

const Education = ({ edu, name, title }) => {

    return (
        <Container maxW='container.lg' className=" bg-gray-100 dark:bg-gray-800 rounded-lg mb-8 ">
            <div className="max-w-screen-xl px-4 py-16 sm:px-6 lg:px-8 ">
                <div className="max-w-xl">
                    <h2 className="text-3xl font-bold font-mono  font-bold">
                        {name}
                    </h2>

                    <p className="mt-4 font-mono font-bold">
                        {title}
                    </p>
                </div>

                <div className="grid grid-cols-1 gap-8 mt-8 md:gap-12 md:mt-16 md:grid-cols-2 lg:grid-cols-3 font-mono font-semibold">
                    {edu?.sort().map(ed => {
                        const { insName, title, grade, duration, web, text } = ed ?? {};
                        return <Educard instName={insName} title={title} grade={grade} duration={duration} web={web} text={text} />
                    })}
                </div>
            </div>
        </Container>
    );
};

export default Education;